'use client';

import { useDialogStore } from '@up2promo-setup-frontend/core/store/dialog.store';
import { type ComponentType, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

function DialogRenderer({
  component,
  props,
}: {
  component: ComponentType<Record<string, unknown>>;
  props: Record<string, unknown> | null;
}) {
  const Component = component;
  return <Component {...(props || {})} />;
}

export function DialogManager({ children }: { children: ReactNode }) {
  const component = useDialogStore((state) => state.component);
  const props = useDialogStore((state) => state.props);
  const isOpen = useDialogStore((state) => state.isOpen);

  return (
    <>
      {children}
      {isOpen && component
        ? createPortal(
            <DialogRenderer component={component} props={props} />,
            document.body,
          )
        : null}
    </>
  );
}
